module.exports = __webpack_public_path__ + "img/de_wit.cda3b836.png";